import React from "react";

import Text from "src/components/text";
import { SearchQueryItem } from "src/types/reports";

import styles from "./searchQueryListItem.module.scss";

export interface SearchQueryListItemProps {
  item: SearchQueryItem;
  columnCount: number;
}

export const SearchQueryListItem: React.FC<SearchQueryListItemProps> = ({
  item,
  columnCount,
}) => {
  return (
    <div key={item.id} className={styles.tableRow}>
      <div className={styles.tableDataContainer}>
        <div className={styles.queryItem}>
          <div className={styles.queryNumber}>{item.manualIndex}</div>
          <div className={styles.rightData}>
            <Text
              lines={1}
              className={styles.searchTags}
              text={item.query || ""}
            />
          </div>
        </div>
      </div>
      <div className={styles.metricsData}>
        <div
          className={styles.analyticsContainer}
          style={{
            gridTemplateColumns: `repeat(${columnCount}, minmax(0, 1fr))`,
          }}
        >
          <span className={styles.tableDataShares}>{item.totalCount || 0}</span>
        </div>
      </div>
    </div>
  );
};
